const getDeviceLocation = (nav = navigator) =>
  new Promise((resolve, reject) => {
    if (!nav.geolocation) {
      reject(new Error('not supported'));
    }

    nav.geolocation.getCurrentPosition(resolve);
  });

export default getDeviceLocation;
